class CartDiscount extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.input = this.querySelector('[name="discount"]');
    this.errorElement = this.querySelector('.cart-discount__error');
    this.submitButton = this.querySelector('[type="submit"]');
    this.form?.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(event) {
    event.preventDefault();

    const code = this.input?.value.trim();
    if (!code) return;

    this.clearError();
    this.setLoading(true);

    const sectionsToRender = this.getSectionsToRender();
    const body = JSON.stringify({
      discount: code,
      sections: sectionsToRender.map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          this.showError(parsedState.errors);
          return;
        }

        const invalidDiscount = parsedState.discount_codes?.find(
          (discountCode) => discountCode.applicable === false
        );
        if (invalidDiscount) {
          this.showError(window.cartStrings.discountError);
          return;
        }

        this.updateSections(parsedState, sectionsToRender);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cartData: parsedState });
      })
      .catch(() => {
        this.showError(window.cartStrings.error);
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ];

    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems?.dataset.id) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents',
      });
    }

    const mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter?.dataset.id) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.cart__footer',
      });
    }

    if (document.querySelector('cart-drawer')) {
      sections.push({
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__footer',
      });
    }

    return sections;
  }

  updateSections(parsedState, sectionsToRender) {
    sectionsToRender.forEach((section) => {
      const sectionHtml = parsedState.sections?.[section.section];
      if (!sectionHtml) return;

      if (section.id === 'CartDrawer') {
        const targetElement = document.querySelector(section.selector);
        const sourceElement = new DOMParser()
          .parseFromString(sectionHtml, 'text/html')
          .querySelector(section.selector);
        if (targetElement && sourceElement) {
          targetElement.innerHTML = sourceElement.innerHTML;
        }
        return;
      }

      const rootElement = document.getElementById(section.id);
      if (!rootElement) return;

      const elementToReplace = rootElement.querySelector(section.selector) || rootElement;
      elementToReplace.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
    });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  showError(message) {
    if (!this.errorElement) return;
    this.errorElement.textContent = message;
    this.errorElement.classList.remove('hidden');
  }

  clearError() {
    if (!this.errorElement) return;
    this.errorElement.textContent = '';
    this.errorElement.classList.add('hidden');
  }

  setLoading(loading) {
    this.submitButton?.toggleAttribute('disabled', loading);
    this.input?.toggleAttribute('disabled', loading);
  }
}

customElements.define('cart-discount', CartDiscount);
